export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11009.9bcdd38c.jpg";